export default {
  common: {
    appName: '蜜獾娱乐',
    confirm: '确认',
    cancel: '取消',
    submit: '提交',
    save: '保存',
    usernameRequired: '请输入用户名！',
    passwordRequired: '请输入密码！',
    viewMore: '查看更多',
    refreshSuccess: '刷新成功',
    noMore: '没有更多了',
    emptyData: '暂无数据',
  },
  footer: { home: '首页', lottery: '彩票', game: '预约', video: '视频', mine: '我的' },
  lang: { title: '语言 / Language', current: '当前语言' },
  home: {
    recommendedTasks: '推荐任务',
    popularRanking: '人气排行',
    hotRecommend: '热门推荐',
    playCount: '播放:{count}',
    noticeLoading: '获取中......',
  },
  game: {
    hallTitle: '预约大厅',
    categoryAll: '全部',
  },
  choose: {
    title: '选妃',
    tabCities: '城市大全',
    tabProcess: '流程价格',
    privacyNotice: '本平台全网最真实外围+商务伴游+同城激情，为保证每个用户的个人隐私，客户仅限通过联系接待员或平台资深会员实名推荐才可加入。',
    resourcesQ: '有哪些资源?',
    resourcesA: '网红、模特、空姐、嫩模、大学生，只有您想不到，没有本平台办不到',
    scopeQ: '服务范围?',
    scopeA: '同城免费约炮，任意地点全国空降，国内一二线城市当地均有，三线城市也可通过联系接待员预约安排。',
    book: '预约',
    contactConcierge: '请联系顾问或接待员',
    cityNames: {
      beijing: '北京',
      shanghai: '上海',
      guangzhou: '广州',
      shenzhen: '深圳',
      nanjing: '南京',
      changsha: '长沙',
      chongqing: '重庆',
      xian: '西安',
    },
  },
  lottery: {
    gameRecord: '任务记录',
    orderList: '任务单',
    orderItemDetail: '1注X{money}元={money}元',
    clearOrder: '清空订单',
    confirmSubmit: '确认提交',
    availableBalance: '可用余额',
    yuan: '元',
    currentPick: '当前选号：',
    amountPerBet: '每注金额：',
    amountPlaceholder: '请输入金额',
    amountInvalid: '金额错误！',
    fillAmount: '请填写金额！',
    selectNumberFirst: '请选号！',
    insufficientBalance: '余额不足，请联系客服充值！',
    notSelected: '未选中',
    contactAdminForTask: '请联系管理员领取该任务！',
    drawSuccess: '开奖成功，期号：{expect}',
    periodNumber: '期号',
    betUnit: '注',
    totalAmountLabel: '总金额：',
    totalCountLabel: '总注数：',
    drawResult: '开奖号码',
    big: '大',
    small: '小',
    single: '单',
    doubleNum: '双',
    rules: {
      title: '玩法规则',
      tipTitle: '玩法提示',
      tipDetail: '从可选和值形态里面选择号码进行下注',
      winTitle: '中奖说明',
      winDetail: '三个开奖号码总和值11~18 为大;总和值3~ 10为小;',
      exampleTitle: '投注范例',
      exampleDetail: '投注方案：小 开奖号码：123,即中小',
    },
  },
  mine: {
    accountDetail: {
      kind: { recharge: '充值', withdraw: '提现', game: '投注' },
    },
    withdraw: {
      amountLabel: '提现金额 (元)',
      all: '全部',
      limitRule1: '1.单笔限额：最低{min}元，最高{max}元',
      limitRule2: '2.提现次数：一天最高提现{num}次',
      limitRule3: '3.到账时间：一般到账时间在5分钟左右，最快2分钟内到账',
      limitTitle: '限额说明',
      balanceLabel: '余额：',
      submit: '马上提现',
      amountInvalid: '请填写正确的金额',
    },
    bindCard: {
      formLabel: '请输入您的收款卡信息',
      bankidLabel: '银行卡号',
      bankidPlaceholder: '请输入真实银行卡号',
      bankLabel: '银行名称',
      bankPlaceholder: '请选择银行',
      notice: '尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款',
      submit: '确认绑卡',
      bankidRequired: '请输入银行卡号！',
      bankRequired: '请选择银行！',
    },
    setbank: {
      title: '收款卡信息',
      addCard: '添加收款卡',
      tips: '提示:请绑定大型商业银行,如需修改,请您联系在线客服',
      setNameFirst: '请设置姓名后再绑定银行卡！',
      setPayPasswordFirst: '请设置提现密码后再绑定银行卡！',
    },
    setPayPassword: {
      firstPrompt: '请输入资金密码',
      secondPrompt: '请再次输入资金密码',
      incomplete: '请填写完整',
      mismatch: '两次密码不一致！',
    },
    setLoginPassword: {
      oldPassword: '旧密码',
      oldPasswordPlaceholder: '请输入您的旧密码',
      newPassword: '新密码',
      newPasswordPlaceholder: '请输入您的新密码',
      confirmPasswordPlaceholder: '请再次输入您的新密码',
      incomplete: '请填写完整！',
      mismatch: '两次密码输入不一致',
    },
    setname: {
      nameLabel: '姓名',
      namePlaceholder: '请输入真实姓名',
      notice: '为了您账户安全,真实姓名需要与绑定银行卡姓名一致',
      alreadySet: '请勿重复设置！',
      nameRequired: '请输入姓名！',
    },
    setsex: {
      male: '男',
      female: '女',
    },
    infomation: {
      avatar: '头像',
      chooseAvatar: '选择头像',
      realName: '真实姓名',
      notSet: '未设置',
      gender: '性别',
      unknown: '未知',
      bindInfo: '绑定信息',
      bound: '已绑定',
      none: '无',
    },
    index: {
      recharge: '充值',
      withdraw: '提现',
      myWallet: '我的钱包',
      details: '明细',
      balanceLabel: '余额：',
      personalReport: '个人报表',
      accountDetail: '账号明细',
      profileCenter: '个人中心',
      notice: '信息公告',
      customerService: '在线客服',
      completeTaskFirst: '请先完成注册任务',
      contactServiceToRecharge: '请联系在线客服充值',
      setPayoutCardFirst: '请先设置收款卡',
      featureDisabled: '该功能暂未开放',
      accountOffline: '账号下线',
      loginRegister: '登录/注册',
      loginHint: '登录后查看',
    },
    setting: {
      basicInfo: '基本信息',
      loginPassword: '登录密码',
      payPassword: '支付密码',
      payPasswordAlreadySet: '支付密码已设置！',
      signOut: '退出登录',
    },
    gameRecord: {
      betAmount: '下注金额：{money}',
      betTime: '下注时间：{time}',
      settleTime: '结算时间：{time}',
    },
    withdrawRecord: {
      amount: '提现金额：{money}',
      desc: '提现说明：{desc}',
      submitTime: '申请时间：{time}',
      reviewTime: '审核时间：{time}',
    },
    report: {
      profitLabel: '盈亏',
      formulaTip: '盈亏 = 中奖金额 - 投注金额 + 充值 - 提现',
      playAmount: '投注金额',
      rechargeAmount: '充值金额',
      withdrawAmount: '提现金额',
      winAmount: '中奖金额',
    },
    service: {
      contact: '立即咨询',
      slogan: '有任何问题都可以联系我们',
    },
  },
  video: {
    hallTitle: '视频影院',
    hotRecommend: '热门推荐',
    playCount: '播放:{count}',
    playCountSuffix: '{count}次播放',
    rechargeToWatch: '请充值后观看视频！',
  },
  recharge: {
    title: '充值',
    chooseCoin: '选择币种',
    address: '收款地址',
    copy: '复制地址',
    copied: '已复制',
    amount: '充值金额',
    uploadShot: '上传转账截图',
    submit: '提交充值申请',
    pending: '待审核',
    done: '已入账',
    rejected: '已驳回',
  },
  payMethod: {
    title: '选择收款方式',
    bankCard: '银行卡',
    wallet: '加密钱包',
    unbind: '解绑',
    bindNew: '绑定新地址',
    confirmUnbind: '确认解绑该收款方式？',
    payPassword: '提现密码',
    wrongPassword: '提现密码错误',
    chooseFirst: '请先选择收款方式',
  },
  router: {
    Index: { title: '首页' },
    Home: { title: '首页' },
    Choose: { title: '选妃' },
    List: { title: '选妃列表' },
    Profile: { title: '选妃详情' },
    Mine: { title: '我的' },
    Video: { title: '视频' },
    Game: { title: '游戏' },
    Login: { title: '登录' },
    Register: { title: '注册' },
    ServiceOnline: { title: '在线客服' },
    ServicePage: { title: '在线客服' },
    Setting: { title: '设置' },
    Infomation: { title: '基本信息' },
    Setname: { title: '修改真实姓名' },
    Setsex: { title: '修改性别' },
    SetPayPassword: { title: '支付密码管理' },
    SetLoginPassword: { title: '登录密码管理' },
    Lottery: { title: '详情页面' },
    Notice: { title: '信息公告' },
    PlayVideo: { title: '视频播放' },
    Setbank: { title: '填写收款卡' },
    BindCard: { title: '填写收款卡' },
    Withdraw: { title: '提现' },
    Recharge: { title: '充值' },
    Personalreport: { title: '个人报表' },
    WithdrawRecord: { title: '提现记录' },
    AccountDetail: { title: '账号明细' },
    GameRecord: { title: '任务记录' },
  },
  captcha: {
    placeholder: '图片验证码',
    refresh: '点击刷新',
    error: '验证码错误',
    required: '请输入验证码',
  },
  login: {
    title: '登录',
    usernamePlaceholder: '请输入用户名',
    passwordPlaceholder: '请输入密码',
    forgotPassword: '忘记密码？',
    noAccountRegister: '没有账户？马上注册',
    submit: '登录',
  },
  register: {
    title: '注册',
    usernamePlaceholder: '请输入用户名(6-12个英文字母或数字)',
    passwordPlaceholder: '请输入登录密码(6-12个英文字母或数字)',
    codePlaceholder: '请输入邀请码',
    protocol: '我已经知晓并同意"开户协议"各项条约',
    submit: '注册',
    codeRequired: '请输入邀请码！',
    agreementRequired: '请勾选下方开户协议！',
  },
}
